export default "__VITE_ASSET__D4_$xvLt__"